<template>
  <div class="home">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
        <v-row class="fill-height" align="center" justify="center">
          <div class="text-h1 white--text">
            {{ item.title }}
          </div>
        </v-row></v-carousel-item
      >
    </v-carousel>
    <!-- <div class="container">
      <backtospeisekarte></backtospeisekarte>
    </div> -->
    <v-card>
      <v-card-title class="display-3">
        Beilagen
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="desserts" :search="search" :items-per-page="-1">
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
// import Backtospeisekarte from './Backtospeisekarte.vue';
export default {
  // components: { Backtospeisekarte },
  name: 'Beilagen',
  data() {
    return {
      items: [
      {
          src: require('../assets/images/suesskartoffelpommes.jpg'),
          title: '',
        },
        {
          src: require('../assets/images/reismithintergrund.jpg'),
          title: '',
        },
        {
          src: require('../assets/images/gitterpommes.jpg'),
          title: '',
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: 'G1',
          speise: 'gekochter Reis',
          allergene: '(A)',
          preis: '2,20 €',
        },
        {
          nummer: 'G2',
          speise: 'Sushi Reis',
          allergene: '(A, N)',
          preis: '2,90 €',
        },
        {
          nummer: 'G3',
          speise: 'Gebratene Nudeln',
          allergene: '(A, F, H)',
          preis: '5,10 €',
        },
        {
          nummer: 'G4',
          speise: 'Gebratener Reis',
          allergene: '(A, C, F, N)',
          preis: '5,10 €',
        },
        {
          nummer: 'BG1',
          speise: 'Gitterpommes',
          allergene: '(A, C, F, N)',
          preis: '4,50 €',
        },
        {
          nummer: 'BG2',
          speise: 'Süßkaroffelpommes',
          allergene: '(A, C, F, N)',
          preis: '4,50 €',
        },
      ],
    };
  },
    methods: {
    top() {
      window.scrollTo(0,0);
    }
  },
  created () {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
